import { useState } from "react";
import { useLocation } from "react-router-dom";

export default function MobileFloatingCTA() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Only show on home page on mobile
  if (location.pathname !== "/") return null;

  const scrollToSection = (id: string) => {
    setOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div className="lg:hidden fixed bottom-20 right-4 z-50 flex flex-col items-end gap-2">
      {/* Expanded action buttons */}
      {open && (
        <div className="flex flex-col items-end gap-2 animate-[fadeInUp_0.2s_ease]">
          {/* Donate button */}
          <button
            onClick={() => scrollToSection("infant-donation-form")}
            className="flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-xs font-bold whitespace-nowrap cursor-pointer transition-all active:scale-95"
            style={{
              background: "linear-gradient(135deg, #e11d48, #f43f5e)",
              boxShadow: "0 4px 16px rgba(225,29,72,0.4)",
            }}
          >
            <i className="ri-heart-fill text-sm" />
            Donate — Help an Infant
          </button>

          {/* Post Requirement button */}
          <button
            onClick={() => scrollToSection("home-buyer-requirement-form")}
            className="flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-xs font-bold whitespace-nowrap cursor-pointer transition-all active:scale-95"
            style={{
              background: "linear-gradient(135deg, #B8860B, #FFD700)",
              color: "#1a0f00",
              boxShadow: "0 4px 16px rgba(184,134,11,0.45)",
            }}
          >
            <i className="ri-file-add-line text-sm" />
            Post Bulk Requirement
          </button>
        </div>
      )}

      {/* Main FAB */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-13 h-13 flex items-center justify-center rounded-full text-white cursor-pointer transition-all active:scale-95 hover:scale-105"
        style={{
          width: 52,
          height: 52,
          background: open
            ? "#374151"
            : "linear-gradient(135deg, #B8860B 0%, #FFD700 100%)",
          boxShadow: open
            ? "0 4px 16px rgba(0,0,0,0.3)"
            : "0 4px 20px rgba(184,134,11,0.5)",
          color: open ? "#fff" : "#1a0f00",
        }}
      >
        <i
          className={`text-xl transition-transform duration-200 ${open ? "ri-close-line rotate-90" : "ri-add-line"}`}
        />
      </button>

      {/* Pulse ring when closed */}
      {!open && (
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-30 pointer-events-none"
          style={{ background: "#FFD700" }}
        />
      )}
    </div>
  );
}
